(function () {
  const field = document.querySelector("[data-field]");
  const status = document.querySelector("[data-status]");
  const pauseBtn = document.querySelector("[data-pause]");
  const chips = [...document.querySelectorAll(".swatches [data-print]")];
  if (!field || !chips.length) return;

  const TILE = Number(field.dataset.tile) || 896;
  const SPEED = TILE / (Number(field.dataset.cycle) || 28);
  const rotateMs = Number(field.dataset.rotate) || 7200;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const prints = {};
  const colors = {};
  const sources = {};
  const order = chips.map((chip) => {
    const id = chip.dataset.print;
    prints[id] = chip.dataset.label || id;
    colors[id] = chip.dataset.color || "#f01e65";
    sources[id] = chip.dataset.src;
    return id;
  });

  const body = document.body;
  let current = body.dataset.print || order[0];
  if (!prints[current]) current = order[0];
  let shown = document.querySelector("[data-shown]");
  let hidden = document.querySelector("[data-hidden]");
  let shownBoard = makeBoard(shown.querySelector("[data-board]"));
  let hiddenBoard = makeBoard(hidden.querySelector("[data-board]"));
  let index = Math.max(0, order.indexOf(current));
  let timer = null;
  let paused = reduce;
  let busy = false;
  let queued = null;
  let camX = 0;
  let camY = 0;
  let lastTs = 0;
  const ready = new Map();

  function path(id) {
    return sources[id] || "";
  }

  function makeBoard(root) {
    const live = new Map();
    const pool = [];
    let printId = current;

    function key(tx, ty) {
      return tx + ":" + ty;
    }

    function dress(node) {
      node.style.backgroundColor = colors[printId];
      node.style.backgroundImage = path(printId) ? `url("${path(printId)}")` : "none";
    }

    function acquire() {
      const node = pool.pop() || document.createElement("div");
      node.className = "field-tile";
      node.style.width = TILE + 1 + "px";
      node.style.height = TILE + 1 + "px";
      dress(node);
      return node;
    }

    function spawn(tx, ty) {
      const k = key(tx, ty);
      if (live.has(k)) return;
      const node = acquire();
      node.style.transform = `translate3d(${tx * TILE}px, ${ty * TILE}px, 0)`;
      root.appendChild(node);
      live.set(k, node);
    }

    function despawn(k) {
      const node = live.get(k);
      if (!node) return;
      live.delete(k);
      node.remove();
      pool.push(node);
    }

    function setPrint(id) {
      printId = id;
      live.forEach(dress);
      pool.forEach(dress);
    }

    function sync(x, y, vw, vh) {
      const fracX = x % TILE;
      const fracY = y % TILE;
      const maxTx = Math.floor((fracX + vw) / TILE);
      const maxTy = Math.floor((fracY + vh) / TILE);
      const needed = new Set();
      for (let ty = 0; ty <= maxTy; ty += 1) {
        for (let tx = 0; tx <= maxTx; tx += 1) {
          needed.add(key(tx, ty));
          spawn(tx, ty);
        }
      }
      live.forEach((_, k) => {
        if (!needed.has(k)) despawn(k);
      });
      root.style.transform = `translate3d(${-fracX}px, ${-fracY}px, 0)`;
    }

    return { setPrint, sync };
  }

  function viewSize() {
    return { vw: field.clientWidth, vh: field.clientHeight };
  }

  function syncBoards() {
    const { vw, vh } = viewSize();
    shownBoard.sync(camX, camY, vw, vh);
    hiddenBoard.sync(camX, camY, vw, vh);
  }

  function tick(ts) {
    if (!lastTs) lastTs = ts;
    const dt = Math.min(0.05, (ts - lastTs) / 1000);
    lastTs = ts;
    if (!paused && !reduce && field.dataset.drift !== "false") {
      camX += SPEED * dt;
      camY += SPEED * dt;
    }
    syncBoards();
    requestAnimationFrame(tick);
  }

  function preload(id) {
    if (ready.has(id)) return ready.get(id);
    const job = new Promise((resolve) => {
      const img = new Image();
      const done = () => {
        if (img.decode) img.decode().then(() => resolve(img)).catch(() => resolve(img));
        else resolve(img);
      };
      img.onload = done;
      img.onerror = () => resolve(img);
      img.src = path(id);
    });
    ready.set(id, job);
    return job;
  }

  function mark(id) {
    index = order.indexOf(id);
    body.dataset.print = id;
    body.style.setProperty("--chip", colors[id]);
    if (status) status.textContent = prints[id];
    chips.forEach((chip) => {
      chip.setAttribute("aria-checked", chip.dataset.print === id ? "true" : "false");
    });
  }

  function frames(n) {
    return new Promise((resolve) => {
      const step = () => {
        n -= 1;
        if (n <= 0) resolve();
        else requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }

  function waitAvalanche(layer) {
    return new Promise((resolve) => {
      let settled = false;
      const finish = (event) => {
        if (settled) return;
        if (event && event.animationName && event.animationName !== "avalanche") return;
        settled = true;
        layer.removeEventListener("animationend", finish);
        resolve();
      };
      layer.addEventListener("animationend", finish);
      window.setTimeout(() => finish(), 1550);
    });
  }

  async function avalanche(id) {
    await preload(id);
    hiddenBoard.setPrint(id);
    syncBoards();
    await frames(2);

    hidden.classList.add("is-running");
    await waitAvalanche(hidden);

    hidden.classList.add("is-hold");
    await frames(2);

    shown.classList.remove("is-shown");
    shown.classList.add("is-hidden");
    hidden.classList.remove("is-running", "is-hidden");
    hidden.classList.add("is-shown");
    await frames(1);
    hidden.classList.remove("is-hold");

    const nextShown = hidden;
    const nextHidden = shown;
    const nextShownBoard = hiddenBoard;
    const nextHiddenBoard = shownBoard;
    shown = nextShown;
    hidden = nextHidden;
    shownBoard = nextShownBoard;
    hiddenBoard = nextHiddenBoard;
    shown.removeAttribute("data-hidden");
    shown.setAttribute("data-shown", "");
    hidden.removeAttribute("data-shown");
    hidden.setAttribute("data-hidden", "");
  }

  async function setPrint(id, instant) {
    if (!prints[id] || id === current) return;
    if (busy) {
      queued = id;
      return;
    }
    mark(id);
    if (instant || reduce) {
      shownBoard.setPrint(id);
      hiddenBoard.setPrint(id);
      syncBoards();
      current = id;
      return;
    }
    busy = true;
    await avalanche(id);
    current = id;
    busy = false;
    if (queued) {
      const nextId = queued;
      queued = null;
      setPrint(nextId);
    }
  }

  function next() {
    setPrint(order[(index + 1) % order.length]);
  }

  function armTimer() {
    clearInterval(timer);
    if (rotateMs <= 0) return;
    timer = setInterval(() => {
      if (!busy) next();
    }, rotateMs);
  }

  function play() {
    paused = false;
    body.classList.remove("is-paused");
    if (pauseBtn) pauseBtn.textContent = pauseBtn.dataset.pause || "Pause";
    armTimer();
  }

  function stop() {
    paused = true;
    body.classList.add("is-paused");
    if (pauseBtn) pauseBtn.textContent = pauseBtn.dataset.play || "Play";
    clearInterval(timer);
  }

  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      setPrint(chip.dataset.print);
      if (!paused && !reduce) armTimer();
    });
  });

  if (pauseBtn) {
    pauseBtn.addEventListener("click", () => {
      if (paused) play();
      else stop();
    });
  }

  window.addEventListener("resize", syncBoards);

  order.forEach((id) => preload(id));
  shownBoard.setPrint(current);
  hiddenBoard.setPrint(current);
  mark(current);
  syncBoards();
  requestAnimationFrame(tick);
  if (reduce || field.dataset.autoplay === "false") stop();
  else play();
})();
